<template>
  <div class="message">
    <img class="message__avatar" :src="message.user.avatar" alt>
    <div class="message__body">
      <span class="message__author">{{ message.user.name }}</span>
      <span class="message__text">{{ message.message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: { type: Object, required: true },
  },
}
</script>

<style lang="scss" scoped>
  .message {
    display: flex;
    gap: 14px;
    max-width: 100%;

    &__avatar {
      width: 34px;
      height: 34px;
      border-radius: 100%;
    }

    &__body {
      flex: 1;
      background: #fff;
      border-bottom: 2px solid #C8C8C8;
      border-radius: 8px;
      padding: 14px;
      line-height: 20px;
    }

    &__author {
      font-weight: 700;
      color: #ff8000;
      margin-right: 8px;
      font-size: 15px;  
    }

    &__text {
      color: #252525;
      font-size: 15px;
      word-break: break-word;
    }
  }
</style>